import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  aplicaCoresOneShell,
  carregarEscopoUsuario,
  limparSessao,
  setHeaderSidBarNovo
} from '../../services/authentication/auth';
import { verificaLoginUsuario } from '../../api/autenticacao';
import { signIn } from '../../api/authentication';
import { useMenuSidebar } from '../../contexts/MenuSidebarContext';
import { MODULOS_TAGS } from '../Shared/Enums/ModulosTelasEnum';

const useLoginHook = ({ setEscopoAcesso }) => {
  aplicaCoresOneShell();
  const [isPending, setPending] = useState(false);
  const [loginPending, setLoginPending] = useState(false);
  const [message, setMessage] = useState(false);
  const [valoresForm, setValoresForm] = useState({});
  const [tela, setTela] = useState('login');
  const [tokenCodUser, setTokenCodUser] = useState('');
  const [emailUser, setEmailUser] = useState('');
  const navigate = useNavigate();
  const [valuesPassword, setValuesPassword] = useState({
    password: '',
    showPassword: false
  });
  const { esconderMenuPrincipal, setTemClienteSelecionado } = useMenuSidebar();

  useEffect(() => {
    limparSessao();
    esconderMenuPrincipal();
    setTemClienteSelecionado(false);
  }, []);

  const handleFormSubmit = (values, form) => {
    setMessage(false);
    setValoresForm(values);
    setPending(true);

    const params = {
      login: values.login,
      password: btoa(unescape(encodeURIComponent(values.password)))
    };

    verificaLoginUsuario(params)
      .then(retornoMFA => {
        const retMFA = retornoMFA.data;

        if (retMFA.mfa_disabled) {
          logar(values.login, values.password);
          return;
        }
        if (retMFA.email_invalidado) {
          setEmailValidaToken(values.login);
          // setRedirecionar('/confirmacao');
        }
        if (retMFA.confirmacao) {
          setTela('confirmacao');
        }
        if (retMFA.token_user) {
          setTokenCodUser(retMFA.token_user);
        }
        if (retMFA.message) {
          setMessage(retMFA.message);
        }
        if (retMFA.email) {
          setEmailUser(retMFA.email);
        }
      })
      .catch(() => {
        setMessage('Ocorreu um erro interno, favor contatar o suporte');
        form.resetForm();
      })
      .finally(() => {
        setPending(false);
        form.setSubmitting(false);
      });
  };

  const logar = (loginValue = false, passwordValue = false) => {
    setLoginPending(true);
    const values = { ...valoresForm };

    if (passwordValue && loginValue) {
      values.login = loginValue;
      values.password = passwordValue;
    }

    const params = {
      login: values.login,
      password: btoa(unescape(encodeURIComponent(values.password)))
    };

    signIn(params)
      .then(() => {
        buscaEscopoUsuario();
      })
      .catch(err => {
        setMessage(err);
      });
  };

  const buscaEscopoUsuario = () => {
    const modulos = [MODULOS_TAGS.PLATAFORMA_ONESHELL, MODULOS_TAGS.PLATAFORMA_CAPITAL_FLOW];
    return carregarEscopoUsuario(modulos, setEscopoAcesso)
      .then(() => {
        setHeaderSidBarNovo(true);
        navigate('/home');
      })
      .finally(() => {
        setLoginPending(false);
      });
  };

  const handleChangePassword = prop => event => {
    setValuesPassword({ ...valuesPassword, [prop]: event.target.value });
    setMessage(false);
  };

  const handleClickShowPassword = () => {
    setValuesPassword({
      ...valuesPassword,
      showPassword: !valuesPassword.showPassword
    });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const handleOnChangeInput = () => {
    setMessage(false);
  };

  return {
    valuesPassword,
    loginPending,
    tokenCodUser,
    valoresForm,
    emailUser,
    isPending,
    message,
    tela,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleChangePassword,
    handleOnChangeInput,
    handleFormSubmit,
    setMessage,
    setTela,
    logar
  };
};

export default useLoginHook;
